import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useAuth0 } from '@auth0/auth0-react';
import "../styles/main.css";
import "chart.js/auto";
import ChartJs from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../styles/charts.scss";
import initialWinLossConfig from "./Charts/Configs/WinLoss";
import initialDailyProfitConfig from "./Charts/Configs/DailyProfit";
import "react-datepicker/dist/react-datepicker.css";
import ChallengeCalculator from "./Charts/Simulations";

// Register the plugin
ChartJs.register(ChartDataLabels);

export const Charts = () => {
  const { getAccessTokenSilently, user } = useAuth0();
  const userId = user.sub.split('|')[1];
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dailyProfitConfig, setDailyProfitConfig] = useState(initialDailyProfitConfig);
  const [winLossConfig, setWinLossConfig] = useState(initialWinLossConfig);
  const [startDate, setStartDate] = useState(new Date(new Date().getTime() - 60 * 60 * 24 * 91 * 1000)); //91 days
  const [endDate, setEndDate] = useState(new Date());
  const [riskSize, setRiskSize] = useState(200);
  const [algorithm, setAlgorithm] = useState('krypton');
  const dailyProfitChartRef = useRef(null);
  const winRateChartRef = useRef(null);

  const handleRiskSizeChange = (e) => {
    setRiskSize(e.target.value);
  }

  const handleStartDateChange = (e) => {
    setStartDate(e);
  }

  const handleEndDateChange = (e) => {
    setEndDate(e);
  }

  const handleAlgorithmChange = (e) => {
    setAlgorithm(e.target.value);
  }

  const formatDate = (date) => {
    const d = new Date(date).toDateString();
    const splitDateArray = d.split(' ');
    return `${splitDateArray[1]} ${splitDateArray[2]}, ${splitDateArray[3]}`;
  }

  const validateStartAndEndDate = () => {
    if (new Date(startDate).getTime() > new Date(endDate).getTime()) {
      return false;
    }
    //Can't go back further than a year
    if (new Date(startDate).getTime() < new Date(endDate).getTime() - 60 * 60 * 24 * 365 * 1000) {
      return false;
    }
    return true;
  }

  const getMetrics = async () => {
    const token = await getAccessTokenSilently();
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const params = {
      uid: userId,
    };
    let urlPath = '/api/v2/metrics';
    const body = {
      startDate: new Date(startDate).toDateString(),
      endDate: endDate,
      riskSize: riskSize,
      algorithm: algorithm,
    };
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVERLESS_API_URL}${urlPath}`,
        body,
        {
          headers: headers,
          params: params
        }
      );
      setData(response.data);

    } catch (error) {
      alert('Error occurred. Try again')
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getMetrics();
  }, []);

  useEffect(() => {
    if (data) {
      setDailyProfitConfig({
        ...dailyProfitConfig,
        data: {
          ...dailyProfitConfig.data,
          datasets: [
            {
              ...dailyProfitConfig.data.datasets[0],
              data: data.metrics.dailyProfit.map((day) => day.profit)
            },
            {
              ...dailyProfitConfig.data.datasets[1],
              data: data.metrics.dailyProfit.map((day) => day.peakBalance)
            }
          ],
          labels: data.metrics.dailyProfit.map((day) => day.date)
        }
      });

      setWinLossConfig({
        ...winLossConfig,
        data: {
          ...winLossConfig.data,
          datasets: [{
            ...winLossConfig.data.datasets[0],
            data: [data.metrics.winCount, data.metrics.lossCount]
          }]
        }
      });

    }

  }, [data]);

  useEffect(() => {

    if (dailyProfitChartRef.current) {
      dailyProfitChartRef.current.update();
    }

    if (winRateChartRef.current) {
      winRateChartRef.current.update();
    }
  }, [dailyProfitChartRef, winRateChartRef]);

  const Loading = ({ className }) => {
    return (
      <span
        className={`loading spinner-border text-primary ${className}`}
        role="status"
      ></span>
    );
  };

  return (
    <ChallengeCalculator/>
    // <MonteCarloSimulator/>
    // <div>
    //   <Container className="charts-container">
    //     <Row>
    //       <Col></Col>
    //       <Col
    //         xs={10}
    //         className="bg-light mt-3 ml-3 mb-4 mr-3 pt-3 pb-3 justify-content-left"
    //       >
    //         <h3 className="border-bottom mb-2 pb-2 d-flex align-items-baseline charts-header">
    //           Performance Dashboard
    //         </h3>
    //         <Form.Group
    //           as={Row}
    //           className="align-items-center border-bottom pb-2"
    //         >
    //           {/* Label takes full width on mobile, auto width on large screens */}
    //           <Col className="col-auto">
    //             <Form.Label htmlFor="riskSize" className="fw-bold mb-2 mb-lg-0">
    //               Risk Size:
    //             </Form.Label>
    //           </Col>
    //           {/* Input takes full width on mobile, remaining space on large screens */}
    //           <Col lg={1} className="px-2 px-lg-0">
    //             <Form.Control
    //               id="riskSize"
    //               type="number"
    //               placeholder="Risk size dollar amount"
    //               value={riskSize}
    //               name="riskSize"
    //               onChange={handleRiskSizeChange}
    //               required
    //             />
    //           </Col>
    //           {/* Label takes full width on mobile, auto width on large screens */}
    //           <Col className="col-auto">
    //             <Form.Label
    //               htmlFor="riskSize"
    //               className="fw-bold mb-2 mb-lg-0 mt-2 mt-lg-0 d-none d-lg-block"
    //             >
    //               Dates:
    //             </Form.Label>
    //             <Form.Label
    //               htmlFor="startDate"
    //               className="fw-bold mb-2 mb-lg-0 mt-2 mt-lg-0 d-block d-lg-none"
    //             >
    //               Start Date:
    //             </Form.Label>
    //           </Col>
    //           {/* Input takes full width on mobile, remaining space on large screens */}
    //           <Col lg={2} className="px-2 px-lg-0">
    //             <DatePicker
    //               id="startDate"
    //               name="startDate"
    //               selected={startDate}
    //               onChange={handleStartDateChange}
    //               dateFormat="MMM dd, yyyy"
    //               className="picker"
    //               icon="bi bi-calendar-fill"
    //               showIcon
    //               toggleCalendarOnIconClick
    //               customInput={<Form.Control />}
    //             />
    //           </Col>
    //           <Col className="col-auto d-none d-lg-block">
    //             <span>-</span>
    //           </Col>
    //           <Col className="col-auto d-block d-lg-none">
    //             <Form.Label
    //               htmlFor="endDate"
    //               className="fw-bold mb-2 mb-lg-0 mt-2 mt-lg-0"
    //             >
    //               End Date:
    //             </Form.Label>
    //           </Col>
    //           <Col lg={2} className="px-2 px-lg-0">
    //             <DatePicker
    //               id="endDate"
    //               name="endDate"
    //               selected={endDate}
    //               onChange={handleEndDateChange}
    //               dateFormat="MMM dd, yyyy"
    //               className="picker"
    //               icon="bi bi-calendar-fill"
    //               showIcon
    //               toggleCalendarOnIconClick
    //               customInput={<Form.Control />}
    //             />
    //           </Col>
    //           <Col className="col-auto mt-lg-0 mt-2 mb-lg-0 mb-1 px-2">
    //             <Button
    //               size="sm"
    //               type="submit"
    //               onClick={async (e) => await getMetrics()}
    //               disabled={!validateStartAndEndDate()}
    //             >
    //               Submit
    //             </Button>
    //           </Col>
    //         </Form.Group>
                

    //           {/* <Accordion>
    //             <Accordion.Item eventKey="0">
    //               <Accordion.Header>
    //                 <Form.Label>
    //                   Dashboard Settings
    //                 </Form.Label>
    //               </Accordion.Header>
    //               <Accordion.Body>
    //                 <Row className="mb-1 pb-1">
    //                   <Col>
    //                     <Form.Group
    //                       className="mb-1 pb-1"
    //                       controlId="algorithm"
    //                     >
    //                       <Form.Label>
    //                         Algorithm
    //                       </Form.Label>
    //                       <Form.Select
    //                         value={algorithm}
    //                         name="algorithm"
    //                         onChange={handleAlgorithmChange}
    //                       >
    //                         <option value="krypton">Krypton</option>
    //                         <option value="orion">Orion</option>
    //                         <option value="prometheus">Prometheus</option>
    //                       </Form.Select>
    //                     </Form.Group>
    //                     <Form.Group
    //                       className="mb-1 pb-1"
    //                       controlId="riskSize"
    //                     >
    //                       <Form.Label>
    //                         Risk Size
    //                       </Form.Label>
    //                       <Form.Control
    //                         type="number"
    //                         placeholder="Display metrics for a specific risk size"
    //                         value={riskSize}
    //                         name="riskSize"
    //                         onChange={handleRiskSizeChange}
    //                         required
    //                       />
    //                     </Form.Group>
    //                   </Col>
    //                   <Col>
    //                     <Form.Group className="mb-1 pb-1" controlId="startDate">
    //                       <Form.Label>Start Date</Form.Label>
    //                       <Form.Control
    //                         type="date"
    //                         name="startDate"
    //                         value={formatDate(startDate)}
    //                         onChange={handleStartDateChange}
    //                       />
    //                       <DatePicker
    //                         name="startDate"
    //                         selected={startDate}
    //                         onChange={handleStartDateChange}
    //                         dateFormat="MMM dd, yyyy"
    //                       />
    //                     </Form.Group>
    //                     <Form.Group className="mb-1 pb-1" controlId="endDate">
    //                       <Form.Label>End Date</Form.Label>
    //                       <Form.Control
    //                         type="date"
    //                         name="endDate"
    //                         value={formatDate(endDate)}
    //                         onChange={handleEndDateChange}
    //                       />
    //                       <DatePicker
    //                         name="endDate"
    //                         selected={endDate}
    //                         onChange={handleEndDateChange}
    //                         dateFormat="MMM dd, yyyy"
    //                       />
    //                     </Form.Group>
    //                   </Col>
    //                 </Row>
    //                 <Row>
    //                   <Col className="d-flex justify-content-center">
    //                     <Button
    //                       type="submit"
    //                       onClick={async (e) => await getMetrics()}
    //                       disabled={!validateStartAndEndDate()}
    //                     >
    //                       Submit
    //                     </Button>
    //                   </Col>
    //                 </Row>
    //               </Accordion.Body>
    //             </Accordion.Item>
    //           </Accordion> */}
            
    //         <Row className="pt-4 d-flex justify-content-center">
    //           <Col xl="3" lg="4" md="6" sm="12" xs="12" className="mb-4">
    //             <div className="charts-tile single-value">
    //               <div className="single-tile-icon">
    //                 <i className="bi bi-coin"></i>
    //               </div>

    //               <div className="numbers">
    //                 <p className="card-category">Total Profit</p>
    //                 {loading ? (
    //                   <Loading />
    //                 ) : (
    //                   <h4>{`$${data.metrics.totalProfit.toLocaleString()}`}</h4>
    //                 )}
    //               </div>
    //             </div>
    //           </Col>

    //           <Col
    //             xl="3"
    //             lg="4"
    //             md="6"
    //             sm="12"
    //             xs="12"
    //             className="pt-4 pt-sm-4 pt-md-0 pt-lg-0 pt-xl-0 mb-4"
    //           >
    //             <div className="charts-tile single-value">
    //               <div className="single-tile-icon">
    //                 <i className="bi bi-cash-stack"></i>
    //               </div>

    //               <div className="numbers">
    //                 <p className="card-category">Average Profit</p>
    //                 {loading ? (
    //                   <Loading />
    //                 ) : (
    //                   <h4>{`$${data.metrics.averageProfitPerDay.toLocaleString()}`}</h4>
    //                 )}
    //                 <p className="card-category sub-note">Per Day</p>
    //               </div>
    //             </div>
    //           </Col>

    //           <Col
    //             xl="3"
    //             lg="4"
    //             md="6"
    //             sm="12"
    //             xs="12"
    //             className="pt-4 pt-sm-4 pt-md-0 pt-lg-0 pt-xl-0 mb-4"
    //           >
    //             <div className="charts-tile single-value">
    //               <div className="single-tile-icon">
    //                 <i className="bi bi-wallet"></i>
    //               </div>

    //               <div className="numbers">
    //                 <p className="card-category">Profit Factor</p>
    //                 {loading ? (
    //                   <Loading />
    //                 ) : (
    //                   <h4>{`${data.metrics.profitFactor.toLocaleString()}`}</h4>
    //                 )}
    //               </div>
    //             </div>
    //           </Col>
    //           <Col
    //             xl="3"
    //             lg="4"
    //             md="6"
    //             sm="12"
    //             xs="12"
    //             className="pt-4 pt-sm-4 pt-md-4 pt-lg-0 pt-xl-0 mb-4"
    //           >
    //             <div className="charts-tile single-value">
    //               <div className="single-tile-icon">
    //                 <i className="bi bi-arrow-down-right-square"></i>
    //               </div>

    //               <div className="numbers">
    //                 <p className="card-category">Max Drawdown</p>
    //                 {loading ? (
    //                   <Loading />
    //                 ) : (
    //                   <h4>{`${data.metrics.drawdownPercentage}%`}</h4>
    //                 )}
    //               </div>
    //             </div>
    //           </Col>
    //         </Row>
    //         <Row className="pt-4 pb-4">
    //           <Col>
    //             <div
    //               className="charts-tile chart"
    //               style={{ height: "450px" }}
    //             >
    //               {loading ? (
    //                 <Loading />
    //               ) : (
    //                 <Chart
    //                   ref={dailyProfitChartRef}
    //                   data={dailyProfitConfig.data}
    //                   options={dailyProfitConfig.options}
    //                   plugins={[dailyProfitConfig.chartAreaBackground]}
    //                 />
    //               )}
    //             </div>
    //           </Col>
    //         </Row>
    //         <Row className="pt-4 d-flex justify-content-center">
    //           <Col md="6" className="pt-4 pt-sm-4 pt-md-0 pt-lg-0 pt-xl-0">
    //             <div
    //               className="charts-tile chart"
    //               style={{ height: "250px" }}
    //             >
    //               {loading ? (
    //                 <Loading />
    //               ) : (
    //                 <Chart
    //                   ref={winRateChartRef}
    //                   data={winLossConfig.data}
    //                   options={winLossConfig.options}
    //                 />
    //               )}
    //             </div>
    //           </Col>
    //         </Row>
    //       </Col>
    //       <Col></Col>
    //     </Row>
    //   </Container>
    //   <Container>
    //     <Row>
    //       <Col></Col>
    //       <Col xs={10} className="bg-light mt-3 ml-3 mb-4 mr-3 pt-3 pb-3 justify-content-left">
    //         <h3 className="border-bottom mb-2 pb-2 d-flex align-items-baseline charts-header">
    //           Trade Log
    //           <span><h6 className="ps-3 mb-0">First 100 Trades</h6></span>
    //         </h3>

    //         <TradeTable tradeLog={data && data.tradeLog ? data.tradeLog : []} riskSize={riskSize} algoName={algorithm} />
    //       </Col>
    //       <Col></Col>
    //     </Row>
    //   </Container>
    // </div>
  );
};
